import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Jobs from "../components/Jobs";
import Projects from "../components/Projects";
import Testimonials from "../components/Testimonials";
import SEO from "../components/SEO";

export default ({ data }) => {

  const {
    allStrapiProjects: { nodes: projects },
    allStrapiTestimonials: { nodes: testimonials }
  } = data;
  return <Layout>
    <SEO title="Home" description="this is a homepage" />
    <Hero />
    <Services />
    <Jobs/>
    <Projects projects={projects} title="featured projects"
              showLink />
    <Testimonials testimonials={testimonials} title="Testimonials" showLink />
  </Layout>
}

export const query = graphql`
  {
    allStrapiProjects(filter: {featured: {eq: true}}) {
      nodes {
        title
        description
        github
        id
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        stack {
          id
          name
        }
      }
    }
    allStrapiTestimonials {
      nodes {
        Name
        company
        testimony
        id
        image {
          childImageSharp {
            fluid {
                            ...GatsbyImageSharpFluid

            }
          }
        }
      }
    }
  }
`

